import { MainLayout } from 'shared/ui/layout/main';

import { RoleTabs } from '../tabs';

export function RoleLayout() {
  return <MainLayout tabs={<RoleTabs />} />;
}
